import { browserLogger } from '@newfront-insurance/dd-rum';

const STORAGE_KEY = 'nova-outlook-connect-enabled';

export interface MSGraphManager {
  // Settings
  isEnabled(): boolean;
  enable(): void;
  disable(): void;

  // Feature flag integration
  setFeatureFlagEnabled(enabled: boolean): void;
}

class MSGraphManagerImpl implements MSGraphManager {
  private featureFlagEnabled: boolean = true;

  /**
   * Check if Outlook Connect is enabled by feature flag and user preference
   */
  isEnabled(): boolean {
    if (!this.featureFlagEnabled) {
      return false;
    }

    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const result = stored === 'true';
      return result;
    } catch (error) {
      return false;
    }
  }

  /**
   * Enable Outlook Connect
   */
  enable(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(true));
    browserLogger.debug('[MS Graph Manager] Outlook Connect enabled');
  }

  /**
   * Disable Outlook Connect
   */
  disable(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(false));
    browserLogger.debug('[MS Graph Manager] Outlook Connect disabled');
  }

  /**
   * Set whether the nova-tools-graph-api feature flag is enabled
   */
  setFeatureFlagEnabled(enabled: boolean): void {
    this.featureFlagEnabled = enabled;
    browserLogger.debug('[MS Graph Manager] Feature flag updated', { enabled });
  }
}

// Singleton instance
export const msGraphManager = new MSGraphManagerImpl();
